import _extends from 'babel-runtime/helpers/extends';

import DISTRICTS from '../../VDistpicker/districts';
import { valueEquals } from 'element-ui/lib/utils/util';
import { isObject } from '@/utils/types';

export default {
  // WkDistpicker
  name: 'WkDistpicker',

  components: {},

  inheritAttrs: false,

  props: {
    hideArea: { type: Boolean, default: false },
    onlyProvince: { type: Boolean, default: false },
    value: Array,
    props: Object
  },

  data: function data() {
    return {
      dataValue: []
    };
  },


  computed: {
    options: function options() {
      return this.getOptions();
    },
    config: function config() {
      var props = this.props || {};
      return _extends({
        label: 'name',
        value: 'code'
      }, props);
    }
  },

  watch: {
    value: {
      handler: function handler() {
        this.validateValue();
      },

      immediate: true
    }
  },

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    getOptions: function getOptions() {
      var _this = this;

      var list = DISTRICTS;
      if (!this.onlyProvince && !this.hideArea) {
        return list;
      }

      var newList = [];
      list.forEach(function (provinceItem) {
        var province = {
          code: provinceItem.code,
          name: provinceItem.name
        };
        if (!_this.onlyProvince) {
          province.children = [];
          provinceItem.children.forEach(function (cityItem) {
            var city = {
              code: cityItem.code,
              name: cityItem.name
            };
            province.children.push(city);
            if (!_this.hideArea) {
              city.children = cityItem.children;
            }
          });
        }

        newList.push(province);
      });

      return newList;
    },
    validateValue: function validateValue() {
      var _this2 = this;

      if (this.value && this.value.length) {
        var dataValue = this.value;
        if (isObject(this.value[0])) {
          dataValue = this.value.map(function (item) {
            return item[_this2.config.value];
          });
        }
        if (!valueEquals(dataValue, this.dataValue)) {
          this.dataValue = dataValue;
        }
      } else {
        this.dataValue = [];
      }
    },
    handleChange: function handleChange() {
      var objValue = this.getCascaderValArr(this.dataValue, this.options);
      this.$emit('input', objValue);
      this.$emit('change', objValue);
    },
    getCascaderValArr: function getCascaderValArr(value, data) {
      var res = [];
      if (value.length === 0) return res;
      var index = 0;
      do {
        var findRes = data.find(function (o) {
          return o.code === value[index];
        });
        if (findRes) {
          data = findRes.children || [];
          res.push({
            code: findRes.code,
            name: findRes.name,
            id: index + 1
          });
        }
        index++;
      } while (index <= value.length);
      return res;
    }
  }
};